<% if (Anvil.page.modal.issue.link == 'site' || Anvil.page.modal.issue.link == 'terminal' || Anvil.page.modal.issue.link == 'aee') { %>
<%- include('/ui/form', {
	params: [ 'issue_link_site', Anvil.page.modal.issue ],
	fields: [
		{
			type: 'select',
			name: 'site_id',
			title: 'Telephely',
			params: {
				maxItems: 1,
				options: Anvil.page.modal.sites.data.filter(x => x.company_id == Anvil.page.modal.issue.company_id && x.company_db_id == Anvil.page.modal.issue.company_db_id),
				valueField: 'id',
				labelField: 'name',
				searchField: [ 'name', 'city', 'address' ],
				render: {
					item: (item, esc) => `<div>${esc(item.name)}<br /><small>${esc(item.city)}, ${esc(item.address)}</small></div>`,
					option: (item, esc) => `<div class="option">${esc(item.name)}<br /><small>${esc(item.city)}, ${esc(item.address)}</small></div>`
				}
			},
			unset_value: null,
			attributes: Anvil.page.modal.issue.closed ? { disabled: 'disabled' } : null,
			update: (value) => {

				// Reset values
				Anvil.page.modal.issue.terminal_id = null
				Anvil.page.modal.issue.aee_id = null

				// Re-render terminal picker
				Anvil.render('/issue/modal_edit_panel_link_terminal', {}, '#panel-link-terminal')
				// Re-render aee picker
				Anvil.render('/issue/modal_edit_panel_link_aee', {}, '#panel-link-aee')
			}
		}
	]
}) %>
<% } %>